export const getResourceUrl = (url: string) => {
  const apiUrl = process.env.REACT_APP_API_URL || '';
  return url ? `${apiUrl.replace('api', 'assets')}/${url}` : '';
};
